import { render, staticRenderFns } from "./ActividadPerifericos.vue?vue&type=template&id=c657616e&"
import script from "./ActividadPerifericos.vue?vue&type=script&lang=js&"
export * from "./ActividadPerifericos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c657616e', component.options)
    } else {
      api.reload('c657616e', component.options)
    }
    module.hot.accept("./ActividadPerifericos.vue?vue&type=template&id=c657616e&", function () {
      api.rerender('c657616e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/ActividadPerifericos.vue"
export default component.exports